<template>
  <div class="container p-4">
    <div class="px-3 py-6 aos-init" data-aos="flip-up">
      <div class="row">
        <div
          class="col-sm-8 col-md-6 col-lg-9 col-xl-12 mx-auto max-w-450 border rounded-xl border-gray-400 shadow shadow-lg p-0"
        >
          <div class="fw-bold mb-3 text-center bg-gray-700 m-0 p-4 rounded-top">
            <img
              width="150"
              height="50"
              src="../../assets/images/logo/logo-white-01.svg"
              alt="مرکز مشاوره و روان‌شناسی ارگانیک مایندد"
            />
          </div>

          <div class="accordion" id="accordionAccount">
            <!-- SIGN IN -->
            <div
              class="collapse bs-validate show"
              novalidate=""
              method="post"
              action="#"
              id="accordionAccountSignIn"
              data-bs-parent="#accordionAccount"
            >
              <div class="px-4 py-2">
                <h6>
                  <svg
                    width="18px"
                    height="18px"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path
                      d="m24 12.46a9.6 9.6 0 0 1 -19.2 0h1.07a8.53 8.53 0 1 0 8.53-8.53v-1.07a9.6 9.6 0 0 1 9.6 9.6zm-9.6-3.2a3.2 3.2 0 1 0 3.2 3.2 3.2 3.2 0 0 0 -3.2-3.2zm-2 0-.6-6.67-2.46 1.92-1.46-1.44a4.67 4.67 0 0 0 -5.62-.37l-2.02 1.3a.54.54 0 0 0 -.15.74.54.54 0 0 0 .74.15l2-1.31a3.64 3.64 0 0 1 4.29.22l1.37 1.38-2.29 1.82z"
                    ></path>
                  </svg>
                  اعتبار سنجی
                </h6>
              </div>

              <div novalidate="" class="px-4">
                <div class="form-floating mb-3">
                  <floating-input-with-message
                    containerClass="mb-3"
                    inputType="text"
                    ID="verification_token"
                    ref="verification_token"
                    inputPlaceHolder="tokenCode"
                    v-model:inputValue="entity.verficationCode"
                    labelClass="text-muted small"
                    labelValue="کد اعتبار سنجی"
                    errorMessage="وارد کردن کد اعتبار سنجی الزامی است"
                    erroMessageClass="smaller text-danger"
                  />
                </div>

                <!-- submot button -->
                <div class="d-grid mb-3">
                  <button class="btn btn-blueSite">
                    <span>تایید</span>
                  </button>
                </div>
              </div>
            </div>
            <!-- SIGN IN -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import FloatingInputWithMessage from '../../components/form/floatingInputWithMessage/FloatingInputWithMessage.vue';
export default {
  components: {
    FloatingInputWithMessage,
  },
  data() {
    return {
      entity: {
        verficationCode: '',
      },
    };
  },
  methods: {
    optCridential() {
      if ('OTPCredential' in window) {
        const input = document.querySelector('#verification_token');
        if (!input) return;
        const ac = new AbortController();
        // const form = input.closest('form');
        // if (form) {
        //   form.addEventListener('submit', () => {
        //     ac.abort();
        //   });
        // }
        navigator.credentials
          .get({
            otp: { transport: ['sms'] },
            signal: ac.signal,
          })
          .then((otp) => {
            input.value = otp.code;
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
  },
  async mounted() {
    this.optCridential();
  },
};
</script>
